import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tab from '@material-ui/core/Tab';
import StyleSheet from 'styles'
import { Link } from 'react-router-dom'
import {FormattedMessage} from 'react-intl'

export class NavItem extends Component {
  static propTypes = {
    title: PropTypes.string,
    link: PropTypes.string,
    requires: PropTypes.bool,
    match: PropTypes.string,
  }

  renderDesktop = () => {
    const {title, link, requires, onClick, mobile, children, ...props} = this.props
    return requires === false ? null : (
      <Tab className={styles.tab} label={<FormattedMessage id={title} />} onClick={() => onClick(link)} {...props} />
    )
  }

  renderMobile = () => {
    const {title, link, requires, children} = this.props
    return requires === false ? null : (
      <li>
        <Link to={link} className={this.props.active ? 'active' : ''}>{<FormattedMessage id={title} />}</Link>
        {children}
      </li>
    )
  }

  render = () => {
    if (this.props.mobile)
      return this.renderMobile()

    return this.renderDesktop()
  }
}

const styles = StyleSheet({
  tab: {
    minWidth: 72,
    fontFamily: 'Rubik,sans-serif',
    textTransform: 'uppercase',
    height: 'inherit'
  }
})

export default NavItem

